import CoreResize from '../../mixins/core-resize'

export default
{
    name: 'app-page',

    mixins:
    [
        CoreResize
    ],

    props:
    {
        contentGlobal: { type: Object },
        contentPage: { type: Object },
        params: { type: Object }
    },

    created()
    {
        this.eventHub.$on('page-size-dispatch', this._dispatchSize)
    },

    mounted()
    {
        this.$el.classList.add('is-enter')
        this.$emit('load', this)

        // Fix news bad size on mounted
        setTimeout(() =>
        {
            this.$emit('load', this)
        }, 10)

        // Fix transition page
        setTimeout(() =>
        {
            this.$el.classList.remove('is-enter')
        }, 1000)
    },

    updated()
    {
        this.$emit('load', this)
    },

    destroyed()
    {
        this.eventHub.$off('page-size-dispatch', this._dispatchSize)
    },

    methods:
    {
        _dispatchSize()
        {
            this.$emit('load', this)
        },

        onResized()
        {
            this.$emit('load', this)
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/mixins/app-page/index.js